import { render } from "./PharmacyDashboard.vue?vue&type=template&id=18875376&scoped=true"
import script from "./PharmacyDashboard.vue?vue&type=script&lang=js"
export * from "./PharmacyDashboard.vue?vue&type=script&lang=js"

import "./PharmacyDashboard.vue?vue&type=style&index=0&id=18875376&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18875376"]])

export default __exports__